import {
  Button,
  FileInput,
  Group,
  Modal,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { IconDeviceFloppy, IconUpload } from "@tabler/icons-react"
import { debounce } from "lodash"
import { Owner } from "../../../models/owner.model"
import {
  useImportTenantMutation,
  useLazyGetOwnersOfTenantQuery,
} from "../store/tenant.query"
import { CollectionQuery } from "../../../models/collection.model"

const ImportTenantComponent = ({ open, opened, close }: any) => {
  const params = useParams()
  const currentUser: any = JSON.parse(
    localStorage.getItem("userInfo") as string,
  )
  const [getOwners, owners] = useLazyGetOwnersOfTenantQuery()
  const [ownerSearch, setOwnerSearch] = useState<string | null>(null)
  const [selectedOwner, setSelectedOwner] = useState<string | null>(null)
  const [file, setFile] = useState<any>(null)
  const [importTenant, importResponse] = useImportTenantMutation()
  const [ownersCollection, setOwnersCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
  })

  useEffect(() => {
    getOwners({
      ...ownersCollection,
      filter: [[{ field: "name", operator: "like", value: ownerSearch }]],
    })
  }, [ownerSearch])
  useEffect(() => {
    getOwners(ownersCollection)
  }, [ownersCollection])

  const onImport = () => {
    const formData = new FormData()

    formData.append("file", file)

    importTenant({
      id:
        currentUser?.role?.key == "owner"
          ? (currentUser?.id as string)
          : (selectedOwner as string),
      file: formData,
    }).then((response: any) => {
      close()
    })
  }

  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  function _parsePropertyOwners() {
    let data: { label: string; value: string }[] = []

    owners?.data?.data?.map((owner: Owner) => {
      data.push({ label: owner?.name as string, value: owner?.id as string })
    })

    return data
  }

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close()
        }}
        className="my-modal-content"
        withCloseButton={false}
        title="Import Tenants"
        padding={20}
        size={"sm"}
      >
        <div className="w-full">
          {currentUser?.role?.key !== "owner" && (
            <div className="flex w-full space-x-4  justify-center">
              <Select
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                onKeyDown={debounce(
                  (event: any) => setOwnerSearch(event?.target?.value),
                  1000,
                )}
                searchable
                withAsterisk
                value={selectedOwner}
                onChange={(value: string) => setSelectedOwner(value)}
                // error={errors.ownerId && `${errors?.ownerId?.message}`}
                clearable
                label="Owner"
                placeholder="Select an owner"
                data={_parsePropertyOwners()}
              />
            </div>
          )}
          <div className="flex w-full space-x-4  justify-center">
            <FileInput
              clearable
              className="w-full"
              // error={
              //     profileForm.formState.errors.profileData &&
              //     `${profileForm.formState.errors.profileData?.message}`
              // }
              label="Upload Profile"
              accept="image/png,image/jpeg,image/jpg"
              onChange={(file: any) => setFile(file)}
              icon={<IconUpload size={14} />}
              // {...field}
            />
          </div>
        </div>
        <Group position="right" mt="xl">
          <>
            <Button
              variant="filled"
              className="bg-primary text-white"
              type="button"
              classNames={{ label: "flex space-x-1" }}
              size={"xs"}
              onClick={() => onImport()}
              loading={
                importResponse?.isLoading
                // notificationResponse.isLoading
              }
            >
              <span>
                <IconDeviceFloppy size={22} strokeWidth={1.5} />
              </span>
              <span>Import</span>
            </Button>
          </>
        </Group>
      </Modal>
    </>
  )
}

export default ImportTenantComponent
